import { Button } from "@mui/material";

import { useTheme } from "@mui/styles";
import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getAdaptiveFontSize } from "../../utils/styling.utils";

const ContainedButton = ({
  className,
  children = null,
  variant = "contained",
  color,
  fontColor,
  fontSize,
  styles,
  id,
  onClick = () => {},
}) => {
  const theme = useTheme();
  //Media Queries
  const isSmartphoneScreen = useMediaQuery("(min-width: 0px)");
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmartphoneScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };

  return (
    <div className={className} id={id}>
      <Button
        sx={{
          backgroundColor: color || theme.COLORS.GREEN.green,
          color: fontColor || theme.COLORS.BLUE.darkBlueGreen,
          borderRadius: "120px 0 120px 120px",
          fontWeight: "bold",
          fontSize:
            fontSize || isMediumScreen
              ? getAdaptiveFontSize({
                screenWidthHooks,
                fontSize: 1,
              })
              : "1rem",
          ":hover": {
            backgroundColor: color || theme.COLORS.BLUE.lightBlue2,
          },
          fontFamily: "noto-sans",
          ...styles,
        }}
        variant={variant}
        onClick={onClick}
      >
        {children}
      </Button>
    </div>
  );
};

export default ContainedButton;
